const intentTypes = [
    'related',           // 相关产品
    'complementary',     // 互补产品
];

// 获取推荐产品
async function get_type_recommendations(product_id, type = 'related') {
    try {
        if (!product_id) {
            console.error('产品ID不能为空');
            return null;
        }
       
        // 使用正确的URL格式
        const url = `/recommendations/products.json?product_id=${encodeURIComponent(product_id)}&intent=${type}`;
        const response = await fetch(url);
        
        if (!response.ok) {
            console.error(`获取${type}产品失败，状态码:`, response.status);
            return null;
        }
        
        const data = await response.json();
        console.log(`${type}产品数据:`, data);
        
        if (!data.products || data.products.length === 0) {
            console.log(`没有找到${type}产品`);
            return null;
        }
        
        // 处理每个产品，添加 variantId 和其他有用属性
        data.products.forEach(item => {
            // 格式化价格
            item.price = (item.price / 100).toFixed(2);
            
            // 添加 variantId - 获取第一个可用变体的ID
            // Shopify API 返回的产品数据中，通常 variants 数组包含变体信息
            if (item.variants && item.variants.length > 0) {
                // 查找第一个可用变体（库存大于0或允许售罄）
                const availableVariant = item.variants.find(variant => 
                    variant.available || variant.inventory_quantity > 0
                );
                
                // 如果找到可用变体，使用它的ID，否则使用第一个变体的ID
                item.variantId = availableVariant ? availableVariant.id : item.variants[0].id;
                
                // 同时保存整个变体信息以备后用
                item.variants = item.variants;
            }
        });
        
        return data.products;
        
    } catch (error) {
        console.error(`获取${type}产品时发生错误:`, error);
        return null;
    }
}